module.exports = __webpack_public_path__ + "static/media/TeenBoy.879a9326.png";